import { PaginationInfinityBrowser } from "./paginationInfinityBrowser";


export class PaginationInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        new PaginationInfinityBrowser();
    }
}
